import { useAuth, type DenyReason } from "../auth/AuthProvider";

const MSG: Record<NonNullable<DenyReason>, string> = {
  not_merchant: "Dieses Konto ist kein Händlerkonto. Das Terminal steht nur Händlern zur Verfügung.",
  inactive: "Dieses Händlerkonto ist derzeit nicht aktiv. Bitte an die Administration wenden.",
  no_membership: "Diesem Konto ist kein Händler zugeordnet.",
  no_profile: "Für dieses Konto wurde kein Profil gefunden.",
};

export function AccessDenied() {
  const { denyReason, signOut } = useAuth();
  return (
    <div className="denied">
      <div className="denied__card">
        <h1>Kein Zugriff</h1>
        <p>{denyReason ? MSG[denyReason] : "Für diesen Bereich fehlt die Berechtigung."}</p>
        <button className="btn" onClick={() => void signOut()}>Abmelden</button>
      </div>
    </div>
  );
}
